export default __webpack_public_path__ + "static/Tek_Double_Door-6c3178b17aea63b092a9af09510c794a.png";